import ShareAuth from '@link/share/vendors/firebase';
import { auth } from '@link/supplier/stores';

const supplierAuth = new ShareAuth(auth);

export const storage = supplierAuth.storage;
export default supplierAuth;
